export const CREATE_FILE_REFERENCE_FAILURE = 'CREATE_FILE_REFERENCE_FAILURE';

export const createFileReferenceFailure = (payload: Error) => ({
    type: CREATE_FILE_REFERENCE_FAILURE,
    payload,
});
